import React from 'react'


const Footer = () => {
  return (
    <div >

        <div className="d-flex justify-content-center" >
        <p className="footer-text" style={{ color: '#808eab', fontWeight:'bold' }}>
          Made with <span role="img">❤️</span> by Pintu Kumar
        </p>

        </div>

    </div>
  )
}

export default Footer